import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, Alert, Placeholder } from 'react-bootstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { fetchDirectiva } from '../redux/directivaSlice';
import '../styles/Noticias.css'; // Importamos los mismos estilos

// Añadimos estilos específicos para el header alineado a la izquierda
const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '2rem',
  gap: '1rem',
  justifyContent: 'flex-start' // Alinea a la izquierda
};

const DirectivaSindicatoPage = () => {
  const dispatch = useDispatch();
  const { dirigentes, loading, error } = useSelector((state) => state.directiva);

  useEffect(() => {
    dispatch(fetchDirectiva());
  }, [dispatch]);

  const obtenerImagenPredeterminada = () => {
    const ancho = 400;
    const alto = 400;
    return `https://via.placeholder.com/${ancho}x${alto}?text=Foto+no+disponible`;
  };

  if (error) {
    return (
      <Alert variant="danger" className="mt-4">
        <Alert.Heading>Error</Alert.Heading>
        <p>{error}</p>
      </Alert>
    );
  }

  return (
    <div
      className="my-5"
      style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}
      role="main"
      aria-label="Página de la directiva del sindicato"
    >
      {/* Header con logo y título */}
      <div
        style={headerStyles}
        aria-label="Encabezado de la directiva"
      >
        <img
          src="https://api.sinterec.cl/public/images/SINTEREC_logo.jpg"
          alt="Logo SINTEREC"
          className="sindicato-logo"
          aria-hidden="true"
        />
        <h1
          className="noticias-title"
          aria-level="1"
        >
          Directiva del Sindicato
        </h1>
      </div>

      {loading ? (
        <Row
          className="gy-4"
          aria-label="Directiva cargando"
          role="list"
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <Col
              key={index}
              xs={12}
              md={6}
              lg={4}
              role="listitem"
            >
              <Card
                className="noticias-card"
                aria-hidden="true"
              >
                <div
                  className="card-img-container loading-placeholder"
                  aria-hidden="true"
                />
                <Card.Body>
                  <Placeholder as={Card.Title} animation="glow">
                    <Placeholder xs={8} className="loading-placeholder" />
                  </Placeholder>
                  <Placeholder as={Card.Subtitle} animation="glow">
                    <Placeholder xs={6} className="loading-placeholder" />
                  </Placeholder>
                  <Placeholder as={Card.Text} animation="glow">
                    <Placeholder xs={10} className="loading-placeholder" />
                  </Placeholder>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Row
          className="gy-4"
          role="list"
          aria-label="Lista de miembros de la directiva"
        >
          {dirigentes.map((dirigente) => (
            <Col
              key={dirigente.id}
              xs={12}
              md={6}
              lg={4}
              role="listitem"
              aria-label={`Miembro: ${dirigente.nombre}, ${dirigente.cargo}`}
            >
              <Card className="noticias-card">
                <div className="card-img-container">
                  <LazyLoadImage
                    src={dirigente.imagen_url || obtenerImagenPredeterminada()}
                    alt={`Foto de ${dirigente.nombre}, ${dirigente.cargo}`}
                    effect="blur"
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
                <Card.Body>
                  <Card.Title
                    className="fw-bold"
                    aria-level="2"
                  >
                    {dirigente.nombre}
                  </Card.Title>
                  <Card.Subtitle
                    className="mb-2 text-muted fw-bold"
                    aria-label="Cargo"
                  >
                    {dirigente.cargo}
                  </Card.Subtitle>
                  <Card.Text>
                    <strong className="text-success">Email:</strong>{' '}
                    <a
                      href={`mailto:${dirigente.email}`}
                      className="text-decoration-none text-primary"
                      aria-label={`Enviar correo a ${dirigente.nombre}`}
                    >
                      {dirigente.email}
                    </a>
                  </Card.Text>
                  {dirigente.telefono && (
                    <Card.Text aria-label="Teléfono de contacto">
                      <strong className="text-success">Teléfono:</strong> {dirigente.telefono}
                    </Card.Text>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};


export default DirectivaSindicatoPage;